// extracted by mini-css-extract-plugin
export var childrenContainer = "_4r-0";
export var virtualScrollArea = "_4r-1";